import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class PJSIPConfiguration extends ServiceCRUD {
  constructor() {
    super('/api/pjsip-configurations');
  }
}

export default new PJSIPConfiguration();
